import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

/**
 * AI-powered draft assistant: paste a URL → Claude extracts structured fields.
 * Decoupled from form state — emits the parsed result to `onResult`.
 */
export default function AIDraftAssistant({ url, setUrl, loading, onRun }) {
  return (
    <div className="mt-6 bg-black text-white border border-black p-5">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="w-4 h-4" />
        <span className="font-mono-plex text-xs uppercase tracking-[0.25em]">AI Draft Assistant</span>
      </div>
      <p className="text-sm text-white/80">
        Paste a news article or government document URL. Claude Sonnet 4.5 extracts a structured draft.{" "}
        <b className="text-white">Output is always a draft</b> — verify every citation before publishing.
      </p>
      <div className="mt-3 flex flex-col md:flex-row gap-2">
        <Input
          data-testid="ai-url-input"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://…"
          className="rounded-none bg-white text-black h-11"
        />
        <Button
          data-testid="ai-summarize-btn"
          type="button"
          disabled={loading || !url}
          onClick={onRun}
          className="rounded-none bg-white text-black hover:bg-[#EAEAEA] h-11"
        >
          {loading ? "Analyzing…" : "Draft from URL"}
        </Button>
      </div>
    </div>
  );
}
